import { TZDate } from '@date-fns/tz';
import { addMinutes } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const getLocalTimeZone: () => string | undefined = () => {
  const offset = new Date().getTimezoneOffset();
  let timeZone: string | undefined;

  if (offset !== 0) {
    timeZone = `${offset < 0 ? '+' : '-'}${Math.floor(Math.abs(offset) / 60)
      .toString()
      .padStart(2, '0')}:${Math.floor(Math.abs(offset) % 60)
      .toString()
      .padStart(2, '0')}`;
  }
  return timeZone;
};

export const getTimeOffset = (timezone: string = 'Universal') => {
  const date = new Date();
  return formatInTimeZone(date, timezone, 'XXX');
};

const timezoneRegex = /(?<sign>[+-])?(?<hour>[0-9]{2}):(?<minute>[0-9]{2})/;

export const getTimeOffsetMinutes = (timezone?: string) => {
  const result = timezoneRegex.exec(getTimeOffset(timezone));
  return (
    ((result?.groups?.sign ?? '+') === '+' ? 1 : -1) *
      parseInt(result?.groups?.hour ?? '0') *
      60 +
    parseInt(result?.groups?.minute ?? '0')
  );
};

export const toISOStringWithOffset = (
  date: Date,
  timezone: string = 'Universal',
) => {
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date
    .getHours()
    .toString()
    .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
    .getSeconds()
    .toString()
    .padStart(2, '0')}.${date
    .getMilliseconds()
    .toString()
    .padStart(2, '0')}${getTimeOffset(timezone)}`;
};

export const offsetToProjectTimezone = (
  time: Date,
  timezone?: string,
): Date => {
  return addMinutes(
    time,
    new Date().getTimezoneOffset() -
      new TZDate(new Date(0), timezone ?? 'Asia/Taipei').getTimezoneOffset(),
  );
};
